import React, { useState, useEffect } from 'react'
import { Form as Fomiker, Field as Fieldmik, FieldArray, Formik } from 'formik'
import cogoToast from 'cogo-toast'
import { Form as FormUi, Segment, Container, Button, Header, Input, Table, Dimmer, Loader , Icon} from 'semantic-ui-react'
import { MyTextArea, MyNormalInput } from '../../apiInputComponent/myInput'
import AddTitleBar from '../../titleBar/add_titleBar'
import putAxios from '../../axiosComponent/put'
import moment from 'moment'
import MyVehicleType from '../../apiInputComponent/myVehicleType'
import MyBranchAddVehicle from '../../apiInputComponent/myBranchAddVehicle'
import MyVendor from '../../apiInputComponent/myVendor'
import MyMake from '../../apiInputComponent/myMake'
import MyModel from '../../apiInputComponent/myModel'
import MyOwnership from '../../apiInputComponent/myOwnership'
import { DateData } from '../../apiInputComponent/dateData'
import MyInsuranceCompany from '../../apiInputComponent/myInsCompany'
import SerialNumber from '../../apiInputComponent/serialNumber'
import ReadAxios from '../../axiosComponent/read'
import TyreSerialNumber from '../../apiInputComponent/tyreSerialNumber'
import * as yup from 'yup';
import VehicleAddTyreTable from '../../mastersComponent/vehicles/vehicleAddTyreTable'
import BatterySerialNumber from './batterySerialNumber';
import { DATE_FORMATS, ERROR_MESSAGES } from '../../../utils/constants'
import { AllRegex } from '../../../utils/validation'


const FormikAddVehicle = () => {
  const [postions, setpostions] = useState([])
  const [tyresData, settyresData] = useState([])
  useEffect(() => {

  }, [])
  let getTyreData = (childData) => {
    console.log(childData,'child data')
    settyresData(childData)
  }
  let getDiv = (data) => {
    if (data) {
      return (
        <VehicleAddTyreTable id={data} tyrData={getTyreData} />
      )
    }
  }
  let updateValues = (data) => {
    return data.map((item, idx) => {
      // console.log('-items-', item)
      if (typeof item.serialNo != "undefined" && item != 'undefined') {
        return {
          'positionId': item.positionId,
          'serialNo': item.serialNo,
          'installationDate': item.installationDate ? moment(item.installationDate).format(DATE_FORMATS.DATE_DDMMYYYY ||'DD-MM-YYYY') : '',
          'tyreRun': item.tyreRun,
        }
      }
    })
  }

  let finalVehicleMapping = (vehicleIDFetched, tyreDetails) => {
    let addTyresToVehicle = []
    tyreDetails.forEach((element) => {
      if (element?.serialNo) {
        let temp = {};
        temp.tyreMapId = 0
        temp.vehicleId = vehicleIDFetched
        temp.tyrePositionId = element.positionId
        temp.tyreRun = element.tyreRun
        temp.installationDate = element.installationDate ?  moment(element.installationDate).format(DATE_FORMATS.DATE_YYYYMMDD || 'YYYY-MM-DD') : ""
        temp.serialNo = element.serialNo
        addTyresToVehicle.push(temp)
      }
    })

    if (addTyresToVehicle && addTyresToVehicle?.length > 0) {
      putAxios({
        url: 'masters/vehicleTyreMapping',
        createItems: { mergeTyreMapping: addTyresToVehicle, deleteTyreMapping: [] },
      })
        .then(result => {
          /* result.data.resultSet.forEach(element => {
            element.mergeTyreMapping.message.success.forEach(item => {
              cogoToast.success(item, { hideAfter: '5' })
            })
          }); */
          // cogoToast.success("Added tyre data successfully!!!", { hideAfter: '5' })
          //window.location.href = '/vehicle'
        })
        .catch((err) => {
          cogoToast.error("Error while adding tyre data...", { hideAfter: '5' })
          console.log(err)
        })
    }
  }

  const addBattery = (values, setFieldValue)=>{
    let batteries = values.batteries
    batteries.push({
      batterySerialNo: '',
      batteryInstallationDate: '',
    })
    setFieldValue('batteries', batteries)
  }
  const removeBattery = (index, values, setFieldValue)=>{
    let batteries = values.batteries
    batteries.splice(index,1)
    setFieldValue('batteries', batteries)
  }

  let finalBatteryMapping = (values, vehicleIDFetched) => {
    let batteryMappingData = []
    values.batteries.length > 0 &&
    values.batteries.map((battery)=>{
      let batteryData = {}
      batteryData.batteryMapId = 0
      batteryData.vehicleId = vehicleIDFetched
      batteryData.isDeleted = 0
      batteryData.batteryConsumption = 0
      batteryData.batteryInstallationDate = moment(battery.batteryInstallationDate).format(DATE_FORMATS.DATE_YYYYMMDD ||'YYYY-MM-DD')
      batteryData.batterySerialNo = battery.batterySerialNo.serialNo
      batteryMappingData.push(batteryData)
    })
    putAxios({
      url: 'masters/vehicleBatteryMapping',
      createItems: { mergeBatteryMapping: batteryMappingData, deleteBatteryMapping: [] },
    })
      .then(result => {
        /* result.data.resultSet.forEach(element => {
          element.mergeTyreMapping.message.success.forEach(item => {
            cogoToast.success(item, { hideAfter: '5' })
          })
        }); */
        // cogoToast.success("Added battery data successfully!!!", { hideAfter: '5' })
        //window.location.href = '/vehicle'
      })
      .catch((err) => {
        cogoToast.error("Error while adding battery data...", { hideAfter: '5' })
        console.log(err)
      })
  }


  const validSchema = yup.object({
    vehicleNo: yup.string().matches(AllRegex.VehicleNumber, ERROR_MESSAGES.INVALID_VEHICLE_NO||'Invalid Vehicle Number').required(ERROR_MESSAGES.REQUIRED||'Required'),
    vehicleTypeId: yup.string().required(ERROR_MESSAGES.REQUIRED||'Required'),
    branchId: yup.string().required(ERROR_MESSAGES.REQUIRED||'Required').nullable(),
    vehicleOwner: yup.string().required(ERROR_MESSAGES.REQUIRED||'Required'),
    vehicleOwnerID: yup.string().required(ERROR_MESSAGES.REQUIRED||'Required'),
    transporterId: yup.string().required(ERROR_MESSAGES.REQUIRED||'Required'),
    engineNo: yup.string().matches(AllRegex.engineNo, ERROR_MESSAGES.INVALID_FORMAT||"Invalid Format").max(50, ERROR_MESSAGES.LESS_THAN_CHARECTERS(50)||'Must be less than 50 characters'),
    chassisNo: yup.string().matches(AllRegex.chasisNo, ERROR_MESSAGES.INVALID_FORMAT||"Invalid Format").max(50, ERROR_MESSAGES.LESS_THAN_CHARECTERS(50)||'Must be less than 50 characters'),
    insPolicyNo: yup.string().matches(AllRegex.insurancePolicyNo, ERROR_MESSAGES.INVALID_FORMAT||"Invalid Format").max(50, ERROR_MESSAGES.LESS_THAN_CHARECTERS(50)||'Must be less than 50 characters'),
    fuelTankCapacity: yup.number().min(1, ERROR_MESSAGES.MUST_BE_POSITIVE_NO||'Must be a Valid Positive Number').max(100000000, ERROR_MESSAGES.LESS_THAN(100000000)||'Must be less than 1000000000').optional(),
    valueOfInsurance: yup.number().integer(ERROR_MESSAGES.INS_VALUE||'Insurance Value must be whole number').min(1, ERROR_MESSAGES.MUST_BE_POSITIVE_NO||'Must be a Valid Positive Number').max(100000000, ERROR_MESSAGES.LESS_THAN(100000000)||'Must be less than 1000000000').optional(),
    insPremium: yup.number().integer(ERROR_MESSAGES.INS_PREMIUM||'Insurance Premium must be whole number').min(1, ERROR_MESSAGES.MUST_BE_POSITIVE_NO||'Must be a Valid Positive Number').max(100000000, ERROR_MESSAGES.LESS_THAN(100000000)||'Must be less than 100000000').optional(),
  })
  return (
    <>
      <AddTitleBar Title="New Vehicle" LinkName="/vehicle" />
      <Formik
        initialValues={{
          vehicleNo: '',
          vehicleCode: '',
          vehicleTypeId: '',
          makeId: '',
          modelId: '',
          manufactureDate: '',
          branchId: '',
          purchaseDate: '',
          regDate: '',
          fuelTankCapacity: '',
          rtoLocation: '',
          engineNo: '',
          chassisNo: '',
          transporterId: '',
          vehicleOwnerID: '',
          vehicleOwner: '',
          batteries : [{
            batterySerialNo: '',
            batteryInstallationDate: '',
          }],
          batterySerialNo: '',
          batteryInstallationDate: '',
          batteryConsumption: '',
          insCompanyId: '',
          valueOfInsurance: '',
          insPremium: '',
          insPlaceOfClain: '',
          insVendorId: '',
          insPolicyNo: '',
          insNote: '',
          // vehicleTyres: postions,
          // vehicleTyres: [{
          //     'positionId': '',
          //     'position': '',
          //     'serialNo': '',
          //     'installationDate': '',
          //     'tyreRun': '',
          // }],
        }}

        validationSchema={validSchema}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true)
          // console.log('>>>iii>>>', tyresData)
          let VehicleData = {
            vehicleNumber: values.vehicleNo,
            vehicleCode: values.vehicleCode,
            vehicleTypeId: values.vehicleTypeId,
            makeId: values.makeId,
            modelId: values.modelId,
            manufactureDate: values.manufactureDate ? moment(values.manufactureDate).format(DATE_FORMATS.DATE_YYYYMMDDHHmmss || 'YYYY-MM-DD HH:mm:ss') : '',
            branchId: values.branchId,
            purchaseDate: values.purchaseDate ? moment(values.purchaseDate).format(DATE_FORMATS.DATE_YYYYMMDDHHmmss || 'YYYY-MM-DD HH:mm:ss') : '',
            regDate: values.regDate ? moment(values.regDate).format(DATE_FORMATS.DATE_YYYYMMDDHHmmss || 'YYYY-MM-DD HH:mm:ss') : '',
            fuelTankCapacity: values.fuelTankCapacity,
            rtoLocation: values.rtoLocation,
            engineNo: values.engineNo.toUpperCase(),
            chassisNo: values.chassisNo.toUpperCase(),
            transporterId: values.transporterId,
            vehicleOwner: values.vehicleOwner,
            //batterySerialNo: values.batterySerialNo.serialNo,
            //batteryInstallationDate: values.batteryInstallationDate ? moment(values.batteryInstallationDate).format('DD-MM-YYYY') : '',
            //batteryConsumption: values.batteryConsumption,
            insCompanyId: values.insCompanyId,
            valueOfInsurance: values.valueOfInsurance,
            insPremium: values.insPremium,
            insPlaceOfClain: values.insPlaceOfClain,
            insVendorId: values.insVendorId,
            insPolicyNo: values.insPolicyNo.toUpperCase(),
            insNote: values.insNote,
            //vehicleTyres: updateValues(tyresData),
          }

          // console.log('PPP', VehicleData)
          // return
          putAxios({
            url: 'masters/vehicleMaster',
            createItems: VehicleData,
          })
            .then(async(response) => {
              if (response.data.status == 200 || response.data.status == 201 || response.data.status == 1) {
                cogoToast.success(response.data.message)
                setInterval(() => {
                  window.location.href = '/vehicle'  
                }, 3000);
                let vehicleIDFetched = response.data.vehicle_id
                //Battery
                if(values.batteries.length > 0){
                  let batteries = values.batteries.filter((battery)=> battery.batterySerialNo.serialNo)
                  values.batteries = batteries
                  let successfullBatteries = []
                  if(batteries.length > 0){
                    await Promise.all(batteries.map(async (battery)=>{
                      let batteryInsertData = {
                        "batterySerialNo": battery.batterySerialNo.serialNo,
                        "batteryCode": battery.batterySerialNo.serialNo,
                        "batteryStatusId": 1,
                      }
                      try{
                        let batteryResponse = await putAxios({
                          url: 'masters/battery',
                          createItems: batteryInsertData,
                        })
                        if(batteryResponse?.data?.status == 200){
                          successfullBatteries.push(battery)
                        }else{
                          cogoToast.error(`Error while creating battery (${battery.batterySerialNo.serialNo})- ${batteryResponse.data.message}`)
                        }
                      }catch(err){
                        console.log(err);
                      } 
                    })).then(()=>{
                      values.batteries = successfullBatteries
                      finalBatteryMapping(values, vehicleIDFetched);
                    })
                  }
                }

                //tyre
                let calulatedItr = 0;
                let tyre_data = tyresData.filter((tyre)=> tyre.serialNo)
                let successfull_tyres = []
                await Promise.all(tyre_data.map(async(element, index) => {
                  if (element?.productInventoryId == 0) {
                    let tyreInsertData = {
                      "serialNo": element.serialNo,
                      "tyreCode": element.serialNo,
                      "tyrePositionId": element.positionId,
                      "tyreStatusId": 1,
                      "tyreRun": element.tyreRun,
                      'installationDate': element.installationDate ?  moment(element.installationDate).format(DATE_FORMATS.DATE_YYYYMMDD || 'YYYY-MM-DD') : ""
                    }

                    try{
                      let tyreAddResponse = await putAxios({
                      url: 'masters/tyre',
                      createItems: tyreInsertData,
                    })
                    if(tyreAddResponse.data.status === 200){
                      successfull_tyres.push(element)
                    }else{
                      cogoToast.error(tyreAddResponse.data.message)
                    } 
                  }catch(err){
                    console.log(err);
                  }
                  } else {
                    successfull_tyres.push(element)
                  }
                })).then(()=>{
                  finalVehicleMapping(vehicleIDFetched, successfull_tyres)
                }).catch((err)=>{
                  console.log(err)
                  finalVehicleMapping(vehicleIDFetched, successfull_tyres)
                })
              } else {
                cogoToast.warn(response.data.message)
                setSubmitting(false)
              }
            })
            .catch((err) => {
              setSubmitting(false)
              console.log(err)
            })

        }}
      >
        {({ values,setFieldValue, isSubmitting, handleSubmit, errors, touched }) => {
          values.vehicleTyres = postions
          return (
            <>
              <Dimmer inverted active={isSubmitting}>
                <Loader>Loading...</Loader>
              </Dimmer>
              <Container fluid className="m-2">
                <Fomiker>
                  <Segment>
                    <div className="ui form tiny">
                      <Header color="blue" size="tiny" className="labelName p-bold-500">Basic Details</Header>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Vehicle Number *</label>
                        </FormUi.Field>
                        <FormUi.Field width="3" className={values.vehicleNo ? '' : "error"}>
                          <Fieldmik autoComplete="off" autoCapitalize="true" value={values.vehicleNo.toUpperCase()} component={MyNormalInput} name="vehicleNo" placeholder="Vehicle No." />
                          {touched.vehicleNo && errors.vehicleNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vehicleNo}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Vehicle Type*</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyVehicleType} error={values.vehicleTypeId ? false : true} name="vehicleTypeId" placeholder="Type" />
                          {touched.vehicleTypeId && errors.vehicleTypeId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vehicleTypeId}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Make</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyMake} name="makeId" placeholder="Make" />
                          {touched.makeId && errors.makeId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.makeId}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Model</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={values.makeId ? MyModel : MyNormalInput} readOnly={values.makeId ? false : true} dataId={values.makeId} name="modelId" placeholder="Select Model" />
                          {touched.modelId && errors.modelId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.modelId}</div> : ''}
                        </FormUi.Field>

                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Manufacturing Date</label>
                        </FormUi.Field>
                        <FormUi.Field className='datepic' width="3">
                          <DateData
                            name="manufactureDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Date"
                            selected={values.manufactureDate}
                            customInput={<Input style={{ width: '100%' }} icon="time" iconPosition="left" />}
                          />
                          {touched.manufactureDate && errors.manufactureDate ? <div className="w3-text-red w3-tiny p-bold-600">{errors.manufactureDate}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Branch *</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyBranchAddVehicle} error={values.branchId ? false : true} name="branchId" placeholder="Select Branch" />
                          {touched.branchId && errors.branchId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.branchId}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Purchase Date</label>
                        </FormUi.Field>
                        <FormUi.Field className='datepic' width="3">
                          <DateData
                            name="purchaseDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.DATE_ddMMYYYY ||"dd-MM-yyyy"}
                            placeholderText="Date"
                            selected={values.purchaseDate}
                            customInput={<Input icon="time" iconPosition="left" />}
                          />
                          {touched.purchaseDate && errors.purchaseDate ? <div className="w3-text-red w3-tiny p-bold-600">{errors.purchaseDate}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Registration Date</label>
                        </FormUi.Field>
                        <FormUi.Field className='datepic' width="3">
                          <DateData
                            name="regDate"
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.DATE_ddMMYYYY ||"dd-MM-yyyy"}
                            placeholderText="Date"
                            selected={values.regDate}
                            customInput={<Input icon="time" iconPosition="left" />}
                          />
                          {touched.regDate && errors.regDate ? <div className="w3-text-red w3-tiny p-bold-600">{errors.regDate}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Fuel Tank Capacity (In Liters)</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" type="number" component={MyNormalInput} name="fuelTankCapacity" placeholder="Tank (In Liters)" />
                          {touched.fuelTankCapacity && errors.fuelTankCapacity ? <div className="w3-text-red w3-tiny p-bold-600">{errors.fuelTankCapacity}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">RTO Location</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyNormalInput} name="rtoLocation" placeholder="Location" />
                          {touched.rtoLocation && errors.rtoLocation ? <div className="w3-text-red w3-tiny p-bold-600">{errors.rtoLocation}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Engine No.</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyNormalInput} name="engineNo" placeholder="Engine No." />
                          {touched.engineNo && errors.engineNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.engineNo}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Chassis No.</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyNormalInput} name="chassisNo" placeholder="Chassis No." />
                          {touched.chassisNo && errors.chassisNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.chassisNo}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group >
                        <FormUi.Field width="4">
                          <label className="labelName">Vendor *</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyVendor} name="transporterId" placeholder="Vendor" />
                          {touched.transporterId && errors.transporterId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.transporterId}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Vehicle Ownership *</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyOwnership} error={values.vehicleOwner ? false : true} name="vehicleOwnerID" nameText="vehicleOwner" placeholder="Select Ownership" />
                          {touched.vehicleOwnerID && errors.vehicleOwnerID ? <div className="w3-text-red w3-tiny p-bold-600">{errors.vehicleOwnerID}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>

                    </div>
                  </Segment>

                  {values.vehicleTypeId ? getDiv(values.vehicleTypeId) : ""}

                    <Segment>
                    <div className="ui form tiny">
                      <div className='d-flex mb-2'>
                      <Header color="blue" size="tiny" className="labelName p-bold-500">Battery Details</Header>
                      <Button size="tiny" type="button" className='ml-auto w3-tiny' primary onClick={()=>addBattery(values,setFieldValue)}><Icon name="plus" /> Add Battery</Button>
                      </div>
                {values.batteries.length > 0 && 
                 values.batteries.map((battery, index)=>{
                  return(
                    <>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Battery Serial No.</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={BatterySerialNumber} tyreid={0} name={`batteries[${Number(index)}].batterySerialNo`} placeholder={values?.batteries[index].batterySerialNo?.serialNo ? values.batteries[index].batterySerialNo.serialNo : ""} />
                          {touched.batterySerialNo && errors.batterySerialNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.batterySerialNo}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Battery Installation Date</label>
                        </FormUi.Field>
                        <FormUi.Field className='datepic' width="3">
                          <DateData
                            name={`batteries[${Number(index)}].batteryInstallationDate`}
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat={DATE_FORMATS.DATE_ddMMYYYY ||"dd-MM-yyyy"}
                            placeholderText="Date"
                            selected={values.batteries[index].batteryInstallationDate}
                            customInput={<Input icon="time" iconPosition="left" />}
                          />
                          {touched.batteryInstallationDate && errors.batteryInstallationDate ? <div className="w3-text-red w3-tiny p-bold-600">{errors.batteryInstallationDate}</div> : ''}
                        </FormUi.Field>
                        {index > 0 && <Icon name="remove" className='ml-auto' color='red' onClick={()=>removeBattery(index,values,setFieldValue)}/>}
                      </FormUi.Group>
                      </>
                  )
                  })}
                    </div>
                  </Segment>
                  <Segment>
                    <div className="ui form tiny">
                      <Header color="blue" size="tiny" className="labelName p-bold-500">Insurance Details</Header>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Insurance Company</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyInsuranceCompany} name="insCompanyId" placeholder="" />
                          {touched.insCompanyId && errors.insCompanyId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insCompanyId}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Value of Insurance</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" type="number" component={MyNormalInput} name="valueOfInsurance" placeholder="" />
                          {touched.valueOfInsurance && errors.valueOfInsurance ? <div className="w3-text-red w3-tiny p-bold-600">{errors.valueOfInsurance}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName">Premium</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" type="number" component={MyNormalInput} name="insPremium" placeholder="" />
                          {touched.insPremium && errors.insPremium ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insPremium}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Place of Claim</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyNormalInput} name="insPlaceOfClain" placeholder="" />
                          {touched.insPlaceOfClain && errors.insPlaceOfClain ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insPlaceOfClain}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group >
                        <FormUi.Field width="4">
                          <label className="labelName">Insurance Vendor</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyVendor} name="insVendorId" placeholder="" />
                          {touched.insVendorId && errors.insVendorId ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insVendorId}</div> : ''}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName">Policy Number</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik autoComplete="off" component={MyNormalInput} name="insPolicyNo" placeholder="Number" />
                          {touched.insPolicyNo && errors.insPolicyNo ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insPolicyNo}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                    </div>
                  </Segment>
                  <Segment>
                    <div className="ui form tiny">
                      <FormUi.Group>
                        <FormUi.Field width="6">
                          <label className="labelName">Notes</label>
                          <Fieldmik autoComplete="off" component={MyTextArea} name="insNote" placeholder="Enter Note" />
                          {touched.insNote && errors.insNote ? <div className="w3-text-red w3-tiny p-bold-600">{errors.insNote}</div> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                    </div>
                  </Segment>
                  <center><Button disabled={isSubmitting} onClick={handleSubmit} size="mini" primary type="submit">Submit</Button></center>
                </Fomiker>
              </Container>
            </>
          )
        }

        }
      </Formik>

    </>
  )
}


export default FormikAddVehicle
